"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EXPORT_TASK_STATUS_DICT = exports.EXPORT_TASK_STATUS = exports.EXPORT_DEFAULT_COLUMNS = void 0;
var _dict = require("@ys/utils/lib/dict");
/** 导出任务状态 */
const EXPORT_TASK_STATUS = exports.EXPORT_TASK_STATUS = {
  PENDING: '1',
  COMPLETED: '0',
  PROCESSING: '2',
  FAILED: '4'
};

/** 导出任务状态字典 */
const EXPORT_TASK_STATUS_DICT = exports.EXPORT_TASK_STATUS_DICT = [{
  dictKey: EXPORT_TASK_STATUS.PENDING,
  dictValue: '待执行'
}, {
  dictKey: EXPORT_TASK_STATUS.COMPLETED,
  dictValue: '已完成'
}, {
  dictKey: EXPORT_TASK_STATUS.PROCESSING,
  dictValue: '正在处理'
}, {
  dictKey: EXPORT_TASK_STATUS.FAILED,
  dictValue: '导出失败'
}];
const EXPORT_DEFAULT_COLUMNS = exports.EXPORT_DEFAULT_COLUMNS = [{
  title: '文件名称',
  dataIndex: 'bizName',
  width: 220
}, {
  title: '创建人',
  dataIndex: 'createUserName',
  width: 100
}, {
  title: '导出时间',
  dataIndex: 'createTime',
  width: 180
}, {
  title: '开始时间',
  dataIndex: 'startTime',
  width: 180
}, {
  title: '结束时间',
  dataIndex: 'endTime',
  width: 180
}, {
  title: '处理状态',
  dataIndex: 'status',
  customRender: text => (0, _dict.translate)(text, EXPORT_TASK_STATUS_DICT),
  width: 100
}, {
  title: '导出进度',
  dataIndex: 'processValue',
  width: 100
}, {
  title: '操作',
  fixed: 'right',
  width: 150,
  scopedSlots: {
    customRender: 'operation'
  }
}];